import React, { useState, useCallback } from 'react'
import { Sidebar } from '@/components/admin/organisms/Sidebar'
import { TopBar } from '@/components/admin/organisms/TopBar'
import { PageShell } from '@/components/admin/atoms/layout/PageShell'
import { MainContent } from '@/components/admin/atoms/layout/MainContent'
import { MainArea } from '@/components/admin/atoms/layout/MainArea'
import { Overlay } from '@/components/admin/atoms/layout/Overlay'

interface BreadcrumbItem {
  label: string
  href?: string
}

interface AdminLayoutProps {
  children: React.ReactNode
  breadcrumbs?: BreadcrumbItem[]
  className?: never
}

export const AdminLayout: React.FC<AdminLayoutProps> = ({ children, breadcrumbs }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const toggleSidebar = useCallback(() => setSidebarOpen((prev) => !prev), [])
  const closeSidebar = useCallback(() => setSidebarOpen(false), [])

  return (
    <PageShell>
      <Sidebar open={sidebarOpen} />
      <Overlay visible={sidebarOpen} onClick={closeSidebar} />
      <MainContent>
        <TopBar breadcrumbs={breadcrumbs} onMenuToggle={toggleSidebar} />
        <MainArea>{children}</MainArea>
      </MainContent>
    </PageShell>
  )
}
